/**
 * Outreach.tsx · 09_APP · OS-006 · 2026-10-20 · C50, v70
 *
 * Her words: "should we also be keeping track of the women that I give outreach to and I give a workshop there...
 * Should I keep track on how many women are there?" and "women's empowerment, I talk to about 25 women per session".
 * A headcount, no names, in about 15 seconds: where, how many, talk or workshop, the date (today unless changed).
 * A number from memory is ticked "estimate" and shown as one, so it is never read as a count taken in the room.
 */

import { useState } from "react";
import { os, type Impact } from "../lib/os";

const PLACES = ["Women's Empowerment", "The Table / 3Strands", "Sacramento Family Justice Center"];
const todayLA = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" });

export function OutreachQuick({ onSaved }: { onSaved: (impact: Impact) => void }) {
  const [place, setPlace] = useState<string | null>(null);
  const [other, setOther] = useState("");
  const [n, setN] = useState("");
  const [on, setOn] = useState(todayLA());
  const [kind, setKind] = useState("talk");
  const [est, setEst] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const where = place === "Other" ? other.trim() : place;
  const count = Number.parseInt(n, 10);

  async function save() {
    if (!where || !Number.isFinite(count) || busy) return;
    setBusy(true); setMsg(null);
    try {
      onSaved(await os.outreachLog(where, count, on, kind, est));
      setMsg(`Saved: ${count} women at ${where}${est ? " (estimate)" : ""}.`);
      setPlace(null); setOther(""); setN(""); setEst(false); setOn(todayLA());
    } catch (e) { setMsg(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  }

  return (
    <div className="ref-quick">
      <div className="ref-head"><b>Log an outreach</b></div>
      <div className="ref-chips" role="group" aria-label="Where">
        {[...PLACES, "Other"].map((p) => <button key={p} className={place === p ? "on" : ""} onClick={() => setPlace(p)}>{p}</button>)}
      </div>
      {place === "Other" && <input className="ref-in" value={other} onChange={(e) => setOther(e.target.value)} placeholder="Where was it?" />}
      <div className="out-row">
        <input className="ref-in" type="number" inputMode="numeric" min={0} value={n} onChange={(e) => setN(e.target.value)} placeholder="How many women?" />
        <input className="ref-in" type="date" value={on} onChange={(e) => setOn(e.target.value)} aria-label="Date" />
      </div>
      <div className="ref-chips" role="group" aria-label="Kind">
        {([["talk", "Talk"], ["workshop", "Workshop"], ["event", "Event"]] as const).map(([k, l]) =>
          <button key={k} className={kind === k ? "on" : ""} onClick={() => setKind(k)}>{l}</button>)}
      </div>
      <label className="out-est"><input type="checkbox" checked={est} onChange={(e) => setEst(e.target.checked)} /> This number is an estimate, not counted in the room</label>
      <button className="ref-save" disabled={!where || !Number.isFinite(count) || busy} onClick={() => void save()}>{busy ? "Saving" : "Save"}</button>
      {msg && <p className="ref-ok" role="status">{msg}</p>}
    </div>
  );
}
